import styled from "styled-components"
import { Button } from "@mui/material"
export const SendModal = {
  position: "absolute",
  top: "0%",
  right: "0%",
  height: "auto",
  width: "400px",
  backgroundColor: "background.paper",
  paddingRight: "60px",
  borderRadius: "16px 0px 0px 16px",
  overflowY: "scroll",
}
export const CustomButton = styled(Button)`
  width: 140px;
  height: 48px;
  background: #ffd52b;
  border-radius: 100px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #414141;
`

export const LinkAsOutlinedButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  border: 1px solid rgba(25, 118, 210, 0.5);
  border-radius: 4px;
  color: #1976d2;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 30px;
  &:hover {
    background-color: rgba(25, 118, 210, 0.1);
  }

  &:active {
    background-color: rgba(25, 118, 210, 0.2);
  }
`
